// extracted by mini-css-extract-plugin
module.exports = {"link":"a10a3f92e9--link--cjgbl"};